import axios from "axios";
import { API_BASE } from "../config/api";

const PROD_FALLBACK_API = "https://triothoughtsolution-backend-1.onrender.com";

export function resolveApiBase() {
  if (API_BASE) return API_BASE;
  const host = typeof window !== "undefined" ? window.location.hostname : "";
  const isLocal =
    host === "localhost" ||
    host === "127.0.0.1" ||
    host.startsWith("192.168.") ||
    host.endsWith(".local");
  if (isLocal) {
    return `http://${host || "localhost"}:5000`;
  }
  return PROD_FALLBACK_API;
}

export function apiPath(path) {
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return `${resolveApiBase()}${normalized}`;
}

export async function apiRequest(method, path, options = {}) {
  const url = apiPath(path);
  return axios({ method, url, ...options });
}
